/* istanbul ignore file */
export { default } from './PhotoFeatureCardBlock';
